///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const ChevronRight = ({
  title = messages.chevron.defaultMessage,
  fill = "#0066FA",
  ...props
}) => (
  <svg
    aria-labelledby="chevron"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    {...props}
  >
    <title id="chevron-icon">{title}</title>
    <path fill={fill} d="M5.7 2 4.29 3.41 8.87 8l-4.58 4.59L5.7 14l6-6-6-6Z" />
  </svg>
);

export default ChevronRight;
